<template>
  <div id="navigation" v-bind:class="{open: MenuIsOpen}">
    <b-container fluid class="navi" id="navbar">
      <b-row class="mainnavi border-b">
        <b-col cols="12" md="6" class="fempol-logo padding-navi">
          <router-link to="/" class="normallink">
            <svg class="fempol-logo-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 401.8 31.5"><path d="M0 .5h16.4v3.9h-12V13h12v3.9h-12v14.3H0V.5zm24.1 0h17.4v3.9h-13v9.4h12.6v3.9H28.5v9.5h13.4v4H24.1V.5zM74 .5h4.1v30.7h-4.5V7.3l-9.4 11.9h-.8L53.9 7.3v23.9h-4.4V.5h4.1l10.2 12.6L74 .5zm13.7 0h4.4v30.7h-4.4V.5zm38.6 0h4.2v30.7h-3.9L106.1 7.6v23.6H102V.5h3.6l20.7 23.8V.5zm23.5-.2h3.1l13.7 30.9h-4.5l-4.1-9.1h-13.1l-3.8 9.1h-4.5L149.8.3zm6.4 17.9l-5-11.1-4.5 11.1h9.5zm32 13V.5h9.7c2.9 0 5.3.8 7 2.4s2.6 3.7 2.6 6.4c0 1.8-.4 3.4-1.3 4.7s-2.1 2.4-3.7 3c-1.6.6-3.8.9-6.7.9h-3.2v13.3h-4.4zm8.9-26.8h-4.5V14h4.8c1.8 0 3.2-.4 4.1-1.3 1-.8 1.5-2 1.5-3.6 0-3.2-2-4.7-5.9-4.7zM229.4.1c4.7 0 8.7 1.5 11.8 4.5s4.7 6.8 4.7 11.3-1.6 8.3-4.8 11.2c-3.2 3-7.2 4.4-12 4.4-4.6 0-8.5-1.5-11.6-4.4-3.1-3-4.6-6.7-4.6-11.2 0-4.6 1.6-8.4 4.7-11.4 3.1-2.9 7.1-4.4 11.8-4.4zm.2 4.1c-3.5 0-6.4 1.1-8.7 3.3s-3.4 5-3.4 8.4c0 3.3 1.1 6.1 3.4 8.3 2.3 2.2 5.1 3.3 8.5 3.3s6.3-1.1 8.6-3.4c2.3-2.2 3.4-5 3.4-8.4 0-3.3-1.1-6-3.4-8.2s-5.1-3.3-8.4-3.3zM254.4.5h4.4v26.7h13.8v4h-18.2V.5zm25 0h4.4v30.7h-4.4V.5zm11.6 0h25.6v3.9h-10.7v26.8h-4.4V4.4H291V.5zm32.8 0h4.4v30.7h-4.4V.5zm40.6 23.6v4.8c-3.2 1.8-6.9 2.6-11.2 2.6-3.4 0-6.3-.7-8.7-2.1-2.4-1.4-4.3-3.3-5.7-5.7-1.4-2.4-2.1-5-2.1-7.8 0-4.5 1.6-8.2 4.8-11.3 3.2-3 7.1-4.6 11.8-4.6 3.2 0 6.8.8 10.7 2.5v4.7c-3.6-2.1-7.1-3.1-10.5-3.1-3.5 0-6.4 1.1-8.8 3.3-2.3 2.2-3.5 5-3.5 8.3 0 3.4 1.1 6.1 3.4 8.3s5.2 3.3 8.8 3.3c3.8.2 7.5-.9 11-3.2zM383.8.3h3.1l13.8 30.9h-4.5l-4.1-9.1H379l-3.8 9.1h-4.6L383.8.3zm6.5 17.9l-5-11.1-4.6 11.1h9.6z"/></svg>
          </router-link>
        </b-col>

        <b-col cols="12" md="6" class="status-seite padding-navi">
          <h1 id="navi-overview">{{navigationPlaceholder}}</h1>
        </b-col>
    
        <div class="hamburger">
          <a class="normallink hamburger-link" @click="onHamClicked()">
            <!-- ham desktop -->
            <svg class="hamburger-link-icon hide-mobile" v-bind:class="{hide: MenuIsOpen}" id="hamburger-icon" width="61" height="31px"  xmlns="http://www.w3.org/2000/svg"><g stroke="#000" stroke-width="4" fill="none" fill-rule="evenodd"><path d="M.5 2.5h59.826M.5 15.5h59.826M.5 28.5h59.826"/></g></svg>
            <!-- close desktop -->
            <svg class="hamburger-close-link-icon hide-hamburger hide-mobile" v-bind:class="{hide: !MenuIsOpen}" id="hamburger-close-icon" width="63" height="31" xmlns="http://www.w3.org/2000/svg"><g stroke="#000" stroke-width="4" fill="none" fill-rule="evenodd"><path d="M1.697 2.485l59.606 26.03M61.303 2.485L1.697 28.515"/></g></svg>
            <!-- ham mobile -->
            <svg class="hide-desktop" v-bind:class="{hide: MenuIsOpen}" id="hamburger-icon-mobile" width="46" height="22" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><filter x="-7%" y="-135.3%" width="115.1%" height="350%" filterUnits="objectBoundingBox" id="a"><feGaussianBlur stdDeviation="1.5" in="SourceAlpha" result="shadowBlurInner1"/><feOffset dy="1" in="shadowBlurInner1" result="shadowOffsetInner1"/><feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" in="shadowInnerInner1"/></filter><path d="M.5 18.794H43" id="b"/></defs><g fill="none" fill-rule="evenodd" stroke-linecap="square"><path stroke="#000" stroke-width="3" d="M1.5 1.794H44M1.5 10.794H44"/><g transform="translate(1 1)"><use fill="#000" filter="url(#a)" xlink:href="#b"/><use stroke="#000" stroke-width="3" xlink:href="#b"/></g></g></svg>    
            <!-- close mobile -->
            <svg class="hide-hamburger hide-desktop" v-bind:class="{hide: !MenuIsOpen}" height="22px" id="hamburger-close-icon-mobile" style="enable-background:new 0 0 45.5 21;" version="1.1" viewbox="0 0 45.5 21" width="46px" x="0px" xml:space="preserve" y="0px"><polygon points="45.5,2.8 44.4,0 22.7,8.9 1.1,0 0,2.8 18.8,10.5 0,18.2 1.1,21 22.7,12.1 44.4,21 45.5,18.2 26.7,10.5 "/></svg>
          </a>
        </div>
        <!-- gradient behind ham -->
        <div class="gradient-container">
          <div class="white"></div>
          <div class="gradient"></div>
        </div>
      </b-row>
      <b-row class="subnavi border-b" id="subnavi" v-bind:class="{showSubnavi: MenuIsOpen}">
        <b-col cols="12" md="6" oder="1" order-md="2" class="menupunkte" id="menupunkte-block">
          <div class="menupunkt-container" id="menupunkt-aktuell" v-bind:class="navigationPlaceholder == 'Aktuell' ? 'hide' :''">
              <router-link to="/" class="normallink">
                <h1>Aktuell</h1>
              </router-link>
            </div>
            <div class="menupunkt-container" id="menupunkt-mission" v-bind:class="navigationPlaceholder == 'Mission Statement' ? 'hide' :''">
              <router-link to="/mission-statement" class="normallink">
                <h1>Mission Statement</h1>
              </router-link>
            </div>
             <div class="menupunkt-container" id="menupunkt-mission" v-bind:class="navigationPlaceholder == 'Heft Übersicht' ? 'hide' :''">
              <router-link to="/heft-uebersicht" class="normallink">
                <h1>Heft Übersicht</h1>
              </router-link>
            </div>
            <div class="menupunkt-container" id="menupunkt-archiv" v-bind:class="navigationPlaceholder == 'Artikel Archiv' ? 'hide' :''">
              <router-link to="/artikel-archiv" class="normallink">
                <h1>Artikel Archiv</h1>
              </router-link>
            </div>
            <div class="menupunkt-container" id="menupunkt-redaktion" v-bind:class="navigationPlaceholder == 'Redaktion & Beirat' ? 'hide' :''">
              <router-link to="/redaktion-beirat" class="normallink">
                <h1>Redaktion & Beirat</h1>
              </router-link>
            </div>
            <div class="menupunkt-container " id="menupunkt-info" v-bind:class="navigationPlaceholder == 'Info' ? 'hide' :'' || navigationPlaceholder == 'Abo' ? 'isAbo' :''">
              <router-link to="/info" class="normallink">
                <h1>Info</h1>
              </router-link>
            </div>
            <div class="menupunkt-container " id="menupunkt-abo" v-bind:class="navigationPlaceholder == 'Abo' ? 'hide' :''">
              <router-link to="/abo" class="normallink">
                <h1>Abo</h1>
              </router-link>
            </div>
        </b-col>
        <b-col cols="12" md="6" order="2" order-md="1" class="adresse-menu" id="adress-scroll">
          <h3>
              Zeitschrift für feministische Politikwissenschaft
            </h3>
            <p>Redaktionsanschrift
              <br>
              c/o Universität Tübingen
              <br>
              Institut für Politikwissenschaft
              <br>
              Melanchthonstr. 36
              <br>
              72074 Tübingen
              <br><br>
              redaktion(at)femina-politica.de
              <br>
              <a class="normallink" href="https://www.facebook.com/FeminaPolitica/" target="_blank">Facebook</a>
              <br>
            </p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
const axios = require("axios");

export default {
  name: "navigation",
  components: {
    //Navigation
  },
  props: {
    navigationPlaceholder: String,
  },
  data() {
    return {
      // entries: [],
      MenuIsOpen: false
    };
  },
  created() {
    axios({
      url: "https://craft.femina-politica.de/api",
      method: "POST",
      // data: {
      //   query: `
      //         query {
      //            entries() {

      //           }
      //         }
      //       `,
      // },
    })
    // .then((result) => {
    //   let data = result.data.data.entries;
    //   console.log(data);

    //   // assign the fetched data 2 times, once for manipulation
    //   // once for reseting
    //   this.entries = data;
    //   this.entriesToManipulate = data;
    // });
  },
  mounted() {},
  methods: { 
    onHamClicked (){
      this.MenuIsOpen = !this.MenuIsOpen;
    }
  }
};
</script>

<style lang="scss">
@import "../assets/css/master.scss";
</style>